import { css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../../../../../components-v2/Button';
import { styleSheet } from './styles';

interface AudienceSummarySidebarItem {
	campaignId: string;
	name: string;
	tagCount: number;
	hasAdvancedFilters: boolean;
}

function getStatusText(item: AudienceSummarySidebarItem): string {
	if (item.hasAdvancedFilters) {
		return 'Custom audience';
	}
	if (item.tagCount === 0) {
		return 'No audience';
	}
	return item.tagCount === 1 ? '1 tag' : `${item.tagCount} tags`;
}

function isEmptyAudienceItem(item: AudienceSummarySidebarItem): boolean {
	return item.tagCount === 0 && !item.hasAdvancedFilters;
}

export function AudienceSummarySidebar(props: {
	items: Array<AudienceSummarySidebarItem>;
	ctaText: string;
	disableCta: boolean;
	onCtaClick: () => void;
	children?: React.ReactNode;
}): JSX.Element {
	const { items, ctaText, disableCta, onCtaClick, children } = props;

	return (
		<div className={css(styleSheet.summarySidebarContainer)}>
			{items.length > 0 && (
				<div className={css(styleSheet.summarySidebarList)}>
					{items.map(item => (
						<div key={item.campaignId} className={css(styleSheet.summarySidebarItem)}>
							<span className={css(styleSheet.summarySidebarCampaignName)}>{item.name}</span>
							<span
								className={css(
									styleSheet.summarySidebarStatus,
									isEmptyAudienceItem(item) ? styleSheet.summarySidebarStatusError : null
								)}
							>
								{getStatusText(item)}
							</span>
						</div>
					))}
				</div>
			)}
			{children}
			<Button
				variant='primary'
				size='lg'
				disabled={disableCta}
				onClick={onCtaClick}
				styles={[styleSheet.summarySidebarCta]}
			>
				{ctaText}
			</Button>
		</div>
	);
}
